// src/lib/deleteThreadClient.js
import { getAuth } from "firebase/auth";
import { db, storage } from "@/firebase/config";
import {
  collection, deleteDoc, doc, getDocs, limit, query
} from "@/lib/firestore-instrumented";
import { ref, deleteObject } from "firebase/storage";

export async function deleteThreadViaFunction(hubSlug, threadId) {
  const auth = getAuth();
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) throw new Error("Not signed in");
  const resp = await fetch(process.env.NEXT_PUBLIC_DELETE_THREAD_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${idToken}` },
    body: JSON.stringify({ hubSlug, threadId }),
  });
  if (!resp.ok) throw new Error(`Delete failed (${resp.status})`);
  return await resp.json();
}

// Optional: a pure-client fallback (for local dev if the function isn’t deployed yet).
export async function deleteThreadOnClient(hubSlug, threadId, images=[]) {
  // Delete Storage files for the thread
  for (const it of images) {
    const url = it?.storageURL || it?.src || it;
    if (!url) continue;
    try {
      await deleteObject(ref(storage, url));
    } catch {}
  }
  // Delete replies (paged)
  const repliesCol = collection(db, "discussions", hubSlug, "threads", threadId, "replies");
  // naive pager
  while (true) {
    const page = await getDocs(query(repliesCol, limit(300)));
    if (page.empty) break;
    const batchDeletes = page.docs.map((d) => deleteDoc(d.ref));
    await Promise.all(batchDeletes);
    if (page.size < 300) break;
  }
  // Delete thread doc
  await deleteDoc(doc(db, "discussions", hubSlug, "threads", threadId));
  return { ok: true };
}
